import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const SmallAbout = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="small-about">
      <div className="left" data-aos="fade-up">
        <img
          src="https://static01.nyt.com/images/2020/07/13/dining/13slushies1/13slushies1-mediumSquareAt3X.jpg"
          alt="Drink"
        />
      </div>
      <div className="right" data-aos="fade-up">
        <h1>About us</h1>
        <p>
          Why is drinking fun? In addition to its other effects, alcohol has a
          tendency to loosen up inhibitions and relax the person drinking it.
          For many people, especially in awkward or tense social situations,
          this can be just what they need to relax and enjoy themselves. Alcohol
          is also very effective in reducing shyness and making people feel
          bolder than they usually do, which is the source of the nickname
          “liquid courage.” For people shy about starting conversations with
          strangers, a moderate amount of alcohol can be the push they need to
          try talking to new people, leading many to think getting drunk is fun.
        </p>
        <Link to="/about">
          <div className="btn">Learn More</div>
        </Link>
      </div>
    </div>
  );
};

export default SmallAbout;
